/* global __SOC_EVALUATION_DOCUMENT_ID */

export default function VendorsController(
  $q,
  $rootScope,
  $scope,
  $filter,
  alerts,
  orgDataService,
  reportsDataService,
  vmSharedModelService,
  vendorManagementNavigationService,
  loaderService,
) {
  const vm = this;

  vm.shownVendorCount = 0;
  vm.vendorsPageLimit = 50;
  vm.vendorsPageStartingRecord = 0;

  vm.handleDeletedVendor = _handleDeletedVendor;
  vm.incrementShownVendors = _incrementShownVendors;
  vm.downloadSOCAssistanceDocument = _downloadSOCAssistanceDocument;

  _activate();

  // //////// METHODS //////////

  function _handleDeletedVendor(vendor) {
    vm.vendors.splice(vm.vendors.indexOf(vendor), 1);
  }

  function _incrementShownVendors() {
    vm.shownVendorCount += 50;
  }

  function _activate() {
    _initEventListeners();
    // vmSharedModelService.getRiskTiers(true).then((riskTiers) => {
    //   vm.riskTiers = riskTiers;
    //   dfdActivate.resolve();
    // });
  }

  function _initEventListeners() {
    $scope.$on('refreshVMVendor', (event, opt) => {
      _refreshVendor(opt.vendorId);
    });
  }

  function _refreshVendor(vendorId) {
    loaderService.showViewLoader = true;
    return vmSharedModelService.getVendorDetails(vendorId, true)
      .then((vendor) => {
        vm.vendors = $filter('filter')(vm.vendors, `!${vendorId}`);
        vm.vendors.push(vendor);
        if (vm.vendors.length > 1) {
          vm.vendors = vmSharedModelService.sortByName(vm.vendors);
        }
        // vendorManagementNavigationService.scrollToVendor(vendorId)
        //   .then(() => {
        //     vendorManagementNavigationService.expandVendor(vendorId);
        //   });
      });
  }

  function _downloadSOCAssistanceDocument() {
    alerts.info('Please wait. Download is in progress..');
    orgDataService.downloadDocument(
      __SOC_EVALUATION_DOCUMENT_ID,
    ).then((downloadDocumentResponse) => {
      reportsDataService.download(downloadDocumentResponse);
    });
  }
}

VendorsController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  '$filter',
  'alerts',
  'orgDataService',
  'reportsDataService',
  'vmSharedModelService',
  'vendorManagementNavigationService',
  'loaderService'
];
